var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopStack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 16,
      height: 18
    },
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0216 8.37473V3.2068H8.04416V8.37473L10.7867 6.09731L11.5096 6.69766L7.53288 10L3.55615 6.69766L4.2791 6.09731L7.0216 8.37473Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0216 16.3747V11.2068H8.04416V16.3747L10.7867 14.0973L11.5096 14.6977L7.53288 18L3.55615 14.6977L4.2791 14.0973L7.0216 16.3747Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.0005,
    y: 0.336914,
    width: 1.77778,
    height: 16,
    transform: "rotate(90 16.0005 0.336914)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopStack);
export default __webpack_public_path__ + "static/media/top_stack.2ec3addffadff751abf4c9574156e2b5.svg";
export { ForwardRef as ReactComponent };